module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\n<div class="beff-detail">\n  <div class="printGraphique">\n    <div class="graphiqueZone" style="data-height:150px;data-width:150px"></div>\n  </div>\n  <div class="table_libellesEffectifs">\n    <table style="margin-top:40px;">\n      <tr class="libellePresent"></tr>\n      <tr class="libelleAbsentPrevu"></tr>\n      <tr class="libelleAbsentNonPrevu"></tr>\n      <tr class="libelleIndefini"></tr>\n    </table>\n  </div>\n  <div class="zoneDetailLink"></div>\n  <div class="initializeColors"></div>\n</div>';
}
return __p;
};
